const CaretLeftIcon = () => {
    return (
        <svg width="9px" height="13px" viewBox="0 0 9 13" version="1.1" xmlns="http://www.w3.org/2000/svg" >
            <g id="PathPilotApp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PPMobileSavedJobs" transform="translate(-23, -24)" stroke="#000000" strokeWidth="2">
                    <polyline id="Path" points="30.5 25 24 29.8 30.5 35.1"></polyline>
                </g>
            </g>
        </svg>
    );
}

export default CaretLeftIcon;
